<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7UEETn/tc-custom/9781615950843.jpg?1718183001147" alt="This image is the cover for the book Scavengers, Posadas County Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Scavengers, Posadas County Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The acclaimed New Mexico mystery series continues as a former deputy leads an investigation into a series of perplexing murders.</b></p><p> A man’s body is found in the unforgiving New Mexico desert, his face so smashed that identification is impossible. It’s the beginning of a brutal murder spree that will soon take Posadas County’s new undersheriff, Estelle Reyes-Guzman, into a case that has roots on both sides of the border. </p><p> With the help of retired Sheriff Bill Gastner—now a state livestock inspector—Reyes-Guzman attempts to identify the “Juan” Doe. Another body turns up in a shallow grave, revealing little about the killer, but more about the victims. And when a suspicious fire takes a third life, the terrible twist finally offers the break Estelle has been looking for, one that will lead her back into a harsh, merciless desert where death welcomes all. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steven F. Havill
      </h2>
      
      <p class="authorDescription body article"><P>Steven F. Havill lives with his wife of fifty-three years, Kathleen, in New Mexico. He is the author of thirty-two novels, taught secondary schools for 25 years, and recently earned an AAS degree in gunsmithing.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?71f34342